import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";

export default function useBatchListingsMutations(componentName = "useBatchListingsMutations") {
  const { get, post, put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60; //1 minutes

  const createBatch = useMutation(
    (body: any) => post(`/part/listings/multiple/batch`, body),
    {
      onSuccess: (data, _, __) => {
        // queryClient.invalidateQueries(["parts", "multiple"]);
        return data;
      },
    }
  );

  const bulkPublish = useMutation(
    (body: any) => post(`/bulklisting/publish`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  const bulkRelist = useMutation(
    (body: any) => post(`/bulklisting/relist`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  return {
    createBatch,
    bulkPublish,
    bulkRelist
  };
}
